import BaseTransaction from './BaseTransaction.js';
class ExodusTransaction extends BaseTransaction {
    assetId;
    amount;
    recipient;
    opts;
    isSendAll;
    feeOpts;
    constructor(params) {
        super({ action: 'send', type: 'exodus', kind: params.kind ?? 'transfer' });
        this.assetId = params.assetId;
        this.amount = params.amount;
        this.recipient = params.recipient;
        this.opts = params.opts;
        this.isSendAll = params.isSendAll;
        this.feeOpts = params.feeOpts;
    }
    async validate(_params) {
    }
    async execute(params) {
        const tx = await params.createAndSendTx({
            assetId: params.fromAsset.id,
            amount: this.amount,
            recipient: this.recipient,
            opts: this.opts,
            isSendAll: this.isSendAll,
            feeOpts: this.feeOpts,
        });
        return tx.txId;
    }
    toJSON() {
        return {
            action: this.action,
            type: this.type,
            assetId: this.assetId,
            amount: this.amount,
            recipient: this.recipient,
            opts: this.opts,
            isSendAll: this.isSendAll,
            feeOpts: this.feeOpts,
            kind: this.kind,
        };
    }
}
export default ExodusTransaction;
